import { Autocomplete, Button, Dialog, DialogActions, DialogContent, TextField, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { headerTypographyProps } from '../../../styles/sxStyling';

export interface TemplateOption {
  uuid: string;
  name: string;
}

interface TemplateModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onCreate: (templateUuid: string | null) => void;
  templates: TemplateOption[];
  title?: string;
}

type TemplateDisplay = {
  name: string;
  uuid: string | null;
};

export default function TemplateModal({ isOpen, onCancel, onCreate, templates, title = 'Create from Template' }: TemplateModalProps) {
  const [selectedOption, setSelectedOption] = useState<TemplateDisplay | null>(null);

  const displayOptions: TemplateDisplay[] = useMemo(() => {
    const blankTemplate = { name: 'Blank Template', uuid: null };

    return [
      blankTemplate,
      ..._.sortBy(templates, 'name').map((t) => ({
        name: t.name,
        uuid: t.uuid,
      })),
    ];
  }, [templates]);

  const handleCreate = () => {
    if (!selectedOption) return;
    onCreate(selectedOption.uuid);
  };

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth maxWidth="sm">
      <Typography {...headerTypographyProps} sx={{ m: 2 }}>
        {title}
      </Typography>

      <DialogContent>
        <Autocomplete<TemplateDisplay>
          options={displayOptions}
          value={selectedOption}
          onChange={(_, option) => setSelectedOption(option)}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => <TextField {...params} autoFocus label="Templates" />}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>

        <Button variant="contained" disabled={!selectedOption} color="primary" onClick={handleCreate}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
